import Activity, {
  ActivityOptions,
  ActivityType,
  BaseActivityData,
  BaseActivityDataOptions,
  Changes,
  getDefaults as getActivityDefaults,
} from 'models/Activity';

export interface ReferralDemographicChangesOptions extends ActivityOptions {
  type: ActivityType.REFERRAL_DEMOGRAPHICS_UPDATES;
  data: Partial<BaseActivityDataOptions & { enteredAt: string; changes: Changes }>;
}

export function getDefaults(): ReferralDemographicChangesOptions {
  return {
    ...getActivityDefaults(),
    type: ActivityType.REFERRAL_DEMOGRAPHICS_UPDATES,
    data: {
      ...getActivityDefaults().data,
      enteredAt: '',
      changes: [],
    },
  };
}

export default class ReferralDemographicChanges extends Activity {
  declare type: ActivityType.REFERRAL_DEMOGRAPHICS_UPDATES;
  declare data: BaseActivityData;

  constructor(options: Partial<ReferralDemographicChangesOptions> = {}) {
    const opts = { ...getDefaults(), ...options };

    super(opts);
  }

  get typeLabel() {
    return 'Referral Demographic Information';
  }
}
